<template>
  <div class="form-group row">
    <label class="col-2 text-right"> {{ label }} </label>
    <div class="col-9">
      <div class="mb-2" v-for="(data, i) in datas" :key="i">
        <select
          class="form-control form-control-inline form-wide"
          :class="{
            'is-invalid': currentBnf.isInValid(i),
          }"
          v-model="data.nm"
          alt="ch"
        >
          <option value="">請選擇</option>
          <option
            v-for="(item, index) in families"
            :key="'death_' + index"
            :value="item.name"
          >
            {{ item.name | truncate }}
          </option>
          <option value="法定繼承人">法定繼承人</option>
          <option value="other">其他</option>
        </select>
        <input
          type="text"
          alt="ch"
          maxlength="25"
          class="form-control form-control-inline"
          :class="{
            'is-invalid': currentBnf.isInValid(i),
          }"
          autocomplete="off"
          v-model="data.other"
          v-if="data.nm === 'other'"
          @blur="replacePercentSign(data)"
          @input="replacePercentSign(data)"
        />
        <div
          class="btn btn-icon btn-border-green m-0"
          v-if="i == datas.length - 1"
          @click="currentBnf.addAfter(i)"
        >
          <i class="icon-add_new text-green"></i>
        </div>
        <div
          class="btn btn-icon btn-border-green m-0"
          v-else
          @click="currentBnf.remove(i)"
        >
          <i class="icon-close text-red"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["datas", "families", "label"],
  watch: {
    datas: {
      immediate: true,
      deep: true,
      handler() {
        this.registerHanlink(); // for 難字更新
        this.$emit("input", this.currentBnf);
        if (this.currentBnf.hasInValid()) {
          this.$toast.info({ title: `${this.label}不得重複` });
        }
      }
    }
  },
  methods: {
    getBnf(object) {
      return {
        addAfter(i) {
          object.splice(i + 1, 0, {
            nm: "",
            other: ""
          });
        },
        remove(i) {
          object.splice(i, 1);
        },
        getValues(target = object) {
          return target
            .filter(x => x.nm && x.nm !== "other")
            .map(x => x.nm)
            .concat(
              target.filter(x => x.nm === "other" && x.other).map(x => x.other)
            );
        },
        isInValid(index) {
          const values = this.getValues(object.filter((x, i) => i !== index));
          return [object[index].nm, object[index].other].some(nm =>
            values.includes(nm)
          );
        },
        hasInValid() {
          return object.some((x, i) => this.isInValid(i));
        }
      };
    },
    //將半形%轉換為全形％
    replacePercentSign(data){
      if(data.other.includes('%')){
        data.other = data.other.replaceAll('%','％');
      }
    }
  },
  computed: {
    currentBnf() {
      return this.getBnf(this.datas);
    }
  }
};
</script>
